import transition from "./transition";

const actions = {
    unMuteAutoplay({commit}){
        window.analytics.view();

        commit('updateMutedStatus', false);
        commit('updatePlayed');
        commit('updateAutoplaying');
        commit('play');
    }
};

export default {...actions, ...transition};